// extracted by mini-css-extract-plugin
export default {"flowFinishElements":"flowFinishElements_flowFinishElements__Ay+Yg","leftColumn":"flowFinishElements_leftColumn__jMlQ4","rightColumn":"flowFinishElements_rightColumn__Qpvrv"};